import { render } from "./OpenDateProcess.vue?vue&type=template&id=c8a1fde0&ts=true"
import script from "./OpenDateProcess.vue?vue&type=script&lang=ts"
export * from "./OpenDateProcess.vue?vue&type=script&lang=ts"

import "./OpenDateProcess.vue?vue&type=style&index=0&id=c8a1fde0&lang=css"

import exportComponent from "/home/runner/work/ch-ocean-widget/ch-ocean-widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__